import {useCallback, useEffect, useRef} from 'react';
import {useOperationsContext} from '../../../../../context/OperationsContextProvider';
import AnnouncementCard from './AnnouncementCard';

function Announcements() {
  const {
    announcementData,
    regulationData,
    announcementUrgentData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useOperationsContext();

  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    if (el.scrollHeight - el.scrollTop - el.clientHeight < 200) {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const hasData =
    announcementData.length > 0 ||
    regulationData.length > 0 ||
    announcementUrgentData.length > 0;

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto min-h-0">
      {hasData ? (
        <>
          {regulationData.map((announcement: any, index: number) => (
            <AnnouncementCard
              key={`regulation-${announcement.id || announcement._id || index}`}
              announcement={announcement}
              index={index}
            />
          ))}

          {regulationData.length > 0 && (
            <div className="w-full h-[3px] bg-gray40" />
          )}

          {announcementUrgentData.map((announcement: any, index: number) => (
            <AnnouncementCard
              key={`urgent-${announcement.id || announcement._id || index}`}
              announcement={announcement}
              index={regulationData.length + index}
            />
          ))}

          {announcementData.map((announcement: any, index: number) => (
            <AnnouncementCard
              key={`announcement-${announcement.id || announcement._id || index}`}
              announcement={announcement}
              index={
                regulationData.length + announcementUrgentData.length + index
              }
            />
          ))}
        </>
      ) : (
        <div className="p-3">
          <div className="bg-pastelYellow rounded-lg p-2">
            <p className="text-lg font-semibold text-black m-0 text-center">
              לא נמצאו תוצאות לתצוגה
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Announcements;
